import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IUiAttribut } from '../../attribut-ui.types';
import { MngBaseSubscriptionComponent } from '@mng/mng-base-subscription-component';
import { debounceTime, distinctUntilChanged, Subscription, takeUntil } from 'rxjs';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'mng-mgs-norm-handler-component',
  imports: [MatIcon],
  template: ` <div style="display: flex; gap: 12px; align-items: center">
    <div style="font-size: 10px;">
      <strong>{{ uiAttribut.normDefinitionHandler.label() }}</strong>
    </div>
    <div>
      @if (!uiAttribut.normDefinitionHandler.inNorm()) {
        <mat-icon svgIcon="warning" style="color: #FAC858; height: 18px; width: 18px; " />
      }
    </div>
  </div>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MgsNormHandlerComponent extends MngBaseSubscriptionComponent {
  _uiAttribut: IUiAttribut;

  subscription: Subscription;

  @Input()
  set uiAttribut(value: IUiAttribut) {
    // console.log('!!!!set attribute', value);
    this._uiAttribut = value;

    if (value.attribut.normDefinition) {
      if (this.subscription) {
        this.subscription.unsubscribe();
      }

      this.subscription = this.uiAttribut.formControl.valueChanges
        .pipe(debounceTime(300), distinctUntilChanged(), takeUntil(this.destroy$))
        .subscribe((change) => {
          // console.log('!!!MgsNormHandlerComponent value Change', this.uiAttribut.attribut.definition.label, change);
          value.normDefinitionHandler.attributWert.set(this.uiAttribut.formControl.value);
        });
    }
  }

  get uiAttribut(): IUiAttribut {
    return this._uiAttribut;
  }
}
